/** Hard reload of the current URL. A module of its own so tests can replace it: jsdom's `location.reload` is not configurable. */
export const reloadPage = () => window.location.reload();
